// extracted by mini-css-extract-plugin
export default {"container":"SectionTitle_container__VAw4a","title":"SectionTitle_title__bu-Ev","line":"SectionTitle_line__Fp+Bw"};